import axios from 'axios';
import ConfigConnection from '../config/api.service';
export default class ProfileService{
  // API Instance
  configConnection = new ConfigConnection();
  account(){
    let config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('accountTk')}`}};
    return axios.get(`${this.configConnection.apiInstance}account`, config);
  }

  accountValidate(){
    let config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('accountTk')}`}};
    return axios.post(`${this.configConnection.apiInstance}account/validate`,'', config);
  }

  searchCommerce(){
    let config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('accountTk')}`}};
    return axios.post(`${this.configConnection.apiInstance}account/merchants`, '',config);
  }

  searchOfficeMerchant(conditions){
    let config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('accountTk')}`}};
    return axios.post(`${this.configConnection.apiInstance}account/office_merchants`, conditions ,config);
  }

  searchTransactions(conditions){
    let config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('accountTk')}`}};
    return axios.post(`${this.configConnection.apiInstance}account/transactions`, conditions ,config);
  }

  editAccount(conditions){
    let config = { headers: { Authorization: `Bearer ${sessionStorage.getItem('accountTk')}`}};
    return axios.put(`${this.configConnection.apiInstance}account`, conditions ,config);
  }
}
